import React, { useEffect } from "react";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getClientDetails, 
	doClientCreate, 
	doClientUpdate 
} from "../../../../redux/client/clientState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import SelectWithOthers from "components/fields/SelectWithOthers";
import { getLabel } from "utils";


const ClientForm = ({ 
	getRecord, 
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData, 
	requesting, 
	submitLabel,
	...props
}) => {

	const { TextArea } = Input;
  	const { recordId, mode } = props;
	const [form] = useForm();

	const lobId = Form.useWatch("clt_lob_id", form);
	
  	useEffect(() => {
		if(recordId){
		  getRecord(recordId);
		}
	  }, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { client:clt_name, clt_account_id, address,  ...rest } = recordData;

			const initialValues = {
				...rest,
				...address,
				clt_account_id: recordData?.clt_account_id ?? "",
				clt_name: recordData?.clt_name ?? "",
				clt_lob_id: recordData?.clt_lob_id ?? "",
				clt_lob_name: recordData?.clt_lob_name ?? "",
			};	

	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {
    	try { 
			recordData?.clt_id > 0 ? doUpdate(formData): doCreate(formData);
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
		<Form className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form} 
			onFinish={onSubmit}
		>   
			<FormItem
				name="clt_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">		
				<FormItem className="font-medium mb-2 "
					name="clt_name"
					label="Client Name"
					rules={[requiredField]}
				>
					{mode !== "view" ?
						<Input id="clt_name"
							className="input-field"
							maxLength={100}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_name}
						</label>
					}
				</FormItem>    		            	            
				<FormItem className="font-medium mb-2 "
					name="clt_entity_name"
					label="Entity Name"
					rules={[requiredField]}
				>
					
					{mode !== "view" ? 
						<Input id="clt_entity_name"
							className="input-field"
							maxLength={100}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_entity_name}
						</label>
					}
				</FormItem>
				<FormItem className="font-medium mb-2 "
					label="Client Status"
					name="clt_status_id"
					rules={[requiredField()]}
				>
					{mode !== "view" ?
					<Select id="clt_status_id"
						className="input-field"
						showSearch
						allowClear={true}
						options={recordData?.clientStatusList}
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{getLabel(recordData?.clientStatusList, recordData?.clt_status_id)}
					</label>
					}
				</FormItem>	  
			</div>
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">
				<div className={
						mode !== "view" && lobId === 62
							? "col-span-2" 
							: "col-span-1" 
					}
				>
					<FormItem className="font-medium mb-2 "
						name="clt_lob_id"
						label="Line Of Business"
						rules={[requiredField]}
					>
						{mode !== "view" ? (
						<SelectWithOthers 
							selectFieldName="clt_lob_id"
							selectOptions={recordData?.lineOfBusinessList}
							selectDisplayValue={
							recordData?.clt_lob_id === 62 
								? recordData?.clt_lob_name 
								: getLabel(recordData?.lineOfBusinessList, recordData?.clt_lob_id)
							}
							othersFieldName="clt_lob_name"
							othersDisplayValue={recordData?.clt_lob_name}
							optionOthersId={[62]} 
							othersPlaceholder="Please specify Line of Business"
							mode={mode}
						/>
						) : (
							<label className="text-base label-value dark:text-white">
								{recordData?.clt_lob_id === 62
									? recordData?.clt_lob_name
									: getLabel(recordData?.lineOfBusinessList, recordData?.clt_lob_id)}
							</label>
						)}
					</FormItem>
				</div>
				<FormItem className="font-medium mb-2 "
					name="clt_website_url"
					label="Website"
				>
					{mode !== "view" ?
						<Input id="clt_website_url"
							className="input-field"
							maxLength={100}
							placeholder="example@email.com"
						/>
						: 	
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_website_url}
						</label>
					}
				</FormItem>
			</div>
			<div className="w-full">
				<FormItem className="font-medium mb-2 "
					name="clt_company_info"
					label="Company Information"
					rules={[requiredField]}
				>
					{mode !== "view" ?
						<TextArea id="clt_company_info"
							className="input-field"
							rows={2}
							maxLength={255}		            		
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_company_info}
						</label>
					}
				</FormItem>
			</div>
			{mode !== "view" ? (
				<>
					<div className="w-full">
						<FormItem
							label="Address Line 1"
							name="add_address_line1"
							rules={[requiredField()]}
						>
							<Input type="text"
							className="input-field"
							id="add_address_line1"
							maxLength={100}
							/>
						</FormItem>
					</div>
					<div className="w-full">
						<FormItem
							label="Address Line 2"
							name="add_address_line2"
						>
							<Input type="text"
							className="input-field"
							id="add_address_line2"
							maxLength={100}
							/>
						</FormItem>	
					</div>
					<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">
						<FormItem
							label="City"
							name="add_city"
						>
							<Input type="text"
							className="input-field"
							id="add_city"
							maxLength={50}
							/>
						</FormItem>

						<FormItem
							label="Postal Code"
							name="add_postal_code"
						>
							<Input type="text"
							className="input-field"
							id="add_postal_code"
							maxLength={50}
							/>
						</FormItem>

						<FormItem
							label="Country"
							name="add_country_id"
							rules={[requiredField()]}
						>
							<Select id="add_country_id"
								className="input-field"
								showSearch
								allowClear={true}
								options={recordData?.countryList}
							/>
						</FormItem>
					</div>
				</>
			) : (
				<div className="w-full">
					<FormItem label="Address">
						<label className="text-base label-value dark:text-white">
								{(() => {
								if (!recordData?.address) return "-";

								const parts = [
									recordData?.address?.add_address_line1,
									recordData?.address?.add_address_line2,
									recordData?.address?.add_city,
									recordData?.address?.add_postal_code,
									getLabel(recordData?.countryList, recordData?.address?.add_country_id),
								].filter(Boolean);

								return parts.length > 0 ? parts.join(", ") : "-";
							})()}
						</label>
					</FormItem>
				</div>
			)}

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
					mode={mode}
					recordId={recordData?.clt_id ?? 0}
					isModal={true}
					modalId={recordData?.clt_id > 0 ? 'edit_client' : 'add_client'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					/>
				)}
			</div>
		</Form>	 
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.client.clientDetails?.data,
	requesting: state.client.clientDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getClientDetails(id)),
  	doCreate: (data) => dispatch(doClientCreate(data)),
  	doUpdate: (data) => dispatch(doClientUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientForm);
